export const MFA_CONST = {
  MFA_SKIP: 'mfaSkip'
} as const;
